import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { CHECKOUT_FEATURE, CheckoutRootModule } from '@spartacus/checkout/base/root';
import { checkoutTranslationChunksConfig, checkoutTranslationsEn } from '@spartacus/checkout/base/assets';

@NgModule({
   declarations: [],
   imports: [CheckoutRootModule],
   providers: [
      provideConfig(<CmsConfig>{
         featureModules: {
            [CHECKOUT_FEATURE]: {
               module: async () => import('@spartacus/checkout/base').then(m => m.CheckoutModule),
            },
         },
      }),
      provideConfig(<I18nConfig>{
         i18n: {
            resources: {
               en: checkoutTranslationsEn
            },
            chunks: checkoutTranslationChunksConfig,
         },
      }),
   ],
})
export class CheckoutFeatureModule {}
